import { styled } from '@mui/material';
import { List } from '@mui/material';

export const StyledDrawerList = styled(List)(({ theme }) => ({
  '& .MuiListItemButton-root': {
    color: theme.palette.mode === 'dark' ? '#D7DCE1' : undefined,
    '& .MuiListItemIcon-root': {
      color: theme.palette.mode === 'dark' ? '#D7DCE1' : undefined,
    },
  },
}));
